import getPlayers from '../../modules/players/actions/getPlayers';

export default store => ({
  path: 'players',
  getIndexRoute(nextState, callback) {
    require.ensure([], (require) => callback(null, { component: require('./containers/ListContainer').default }));
  },
  getChildRoutes(location, callback) {
    // do asynchronous stuff to find the child routes
    require.ensure([], (require) => {
      const routes = require('./routes').default;
      callback(null, routes);
    });
  },
  onEnter() {
    store.dispatch(getPlayers());
  },
});



// WEBPACK FOOTER //
// ./src/routes/players/index.js